import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './styles/label.module.scss';
import { TooltipBtn } from '../TooltipBtn';
import { PreviewFieldProps } from './PreviewField';
import { gray } from '../Color';
import { TooltipTip } from '../Tooltip';
import { ThemeStyle } from '../../utils/const';
import { FlexGrid, FlexGridColumn } from '../FlexGrid';
import { InfoCircleO } from '../Icons/InfoCircleO';

type PreviewFieldLabelProps = Pick<PreviewFieldProps, 'tooltip' | 'label' | 'labelBold'>;

export const PreviewFieldLabel: FC<React.PropsWithChildren<PreviewFieldLabelProps>> = ({
	tooltip,
	label,
	labelBold,
}) => {
	const hasTooltip = !!tooltip;

	const labelClasses = classNames(classes.label, {
		[classes.label_bold]: labelBold,
	});

	return (
		<FlexGrid
			gap='scanty'
			className={labelClasses}
		>
			<FlexGridColumn>{label}</FlexGridColumn>
			{hasTooltip && (
				<TooltipBtn
					className={classes.tooltipBtn}
					tooltip={<TooltipTip>{tooltip}</TooltipTip>}
					tooltipTheme={ThemeStyle.Light}
					tooltipPosition='bottom'
					tooltipAlign='start'
					tabIndex={-1}
				>
					<InfoCircleO fill={gray[5]} />
				</TooltipBtn>
			)}
		</FlexGrid>
	);
};
